import script from "./CaptchaLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./CaptchaLogin.vue?vue&type=script&setup=true&lang=ts"

import "./CaptchaLogin.vue?vue&type=style&index=0&id=8bd4b3dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8bd4b3dc"]])

export default __exports__